"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultModalStyles = void 0;
exports.defaultModalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        border: 'unset',
        background: 'unset',
        padding: 'unset',
        borderRadius: 16,
        boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.15)',
    },
};
//# sourceMappingURL=styles.js.map